<template>
  <v-card>
    <v-dialog v-model="alertDialog" max-width="900">
      <ManageAlert
        :key="dialogKey"
        title="Novo alerta"
        :alert="alert"
        :newAlert="true"
        @close="handleCloseDialog"
      />
    </v-dialog>

    <v-card-title>
      <h2 style="font-size: 21px">
        {{ editMode ? 'Editar Documento' : 'Adicionar Documento' }}
      </h2>
    </v-card-title>
    <v-card-text>
      <v-form v-model="localValid" ref="form">
        <label class="label">Nome</label>
        <v-text-field
          placeholder="Nome do Documento"
          class="primary-input"
          outlined
          hide-details="auto"
          v-model="newDocument.name"
          :rules="[(v) => !!v || 'Identificação é obrigatória']"
          required
        ></v-text-field>

        <label class="label">Pastas</label>
        <v-select
          placeholder="Selecione a pasta"
          class="primary-input"
          outlined
          hide-details="auto"
          v-model="newDocument.folderId"
          :items="newDocument.folderId ? allFolders : allFoldersWithoutRemove"
          item-text="name"
          item-value="id"
          :disabled="addToDoMode"
        ></v-select>

        <label class="label">Data de Expiração</label>
        <v-menu
          v-model="localmenuExpireDate"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="formattedExpireDate"
              placeholder="Data de Expiração"
              class="primary-input"
              outlined
              hide-details="auto"
              prepend-inner-icon="mdi-calendar"
              v-bind="attrs"
              v-on="on"
              autocomplete="off"
            >
              <template #message="{ message }">
                {{ $t(message) }}
              </template>
            </v-text-field>
          </template>
          <date-picker
            ref="datepicker"
            style="width: 100%"
            v-model="newDocument.expireDate"
            mode="dateTime"
            is24hr
            :popover="{ visibility: 'click', positionFixed: 'true' }"
          >
          </date-picker>
        </v-menu>

        <label class="label">Documento</label>
        <v-file-input
          :placeholder="
            editMode
              ? `${newDocument.name}.${newDocument.extension}`
              : 'Upload do Documento'
          "
          class="primary-input"
          outlined
          hide-details="auto"
          v-model="newDocument.file"
          accept="*/*"
          prepend-inner-icon="mdi-file"
          prepend-icon=""
          :rules="
            editMode ? [] : [(v) => !!v || 'Upload do Documento é obrigatório']
          "
          required
          :disabled="editMode ? true : false"
        ></v-file-input>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary-button ma-1 mb-4" depressed @click="closeModal"
        >Cancelar</v-btn
      >
      <v-btn
        class="primary-button ma-1 mb-4"
        depressed
        @click="editMode ? updateDocument() : addDocument()"
        :disabled="!localValid"
      >
        {{ editMode ? 'Atualizar' : 'Adicionar' }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import moment from 'moment'
import ManageAlert from '../../Alert/components/manageAlert/ManageAlert.vue'

export default {
  props: {
    editMode: Boolean,
    addToDoMode: Boolean,
    newDocument: Object,
    menuExpireDate: Boolean,
    valid: Boolean,
    allFoldersWithoutRemove: Array,
    allFolders: Array,
  },

  components: {
    ManageAlert,
  },

  data() {
    return {
      localValid: this.valid,
      localmenuExpireDate: this.menuExpireDate,
      alertDialog: false,
      dialogKey: false,
      alert: {},
    }
  },

  computed: {
    formattedExpireDate: {
      get() {
        return this.newDocument.expireDate
          ? moment(this.newDocument.expireDate).format('DD/MM/YYYY')
          : ''
      },
      set(value) {
        const [day, month, year] = value.split('/')
        this.newDocument.expireDate = `${year}-${month}-${day}`
      },
    },
  },
  watch: {
    valid(newVal) {
      this.localValid = newVal
    },
    menuExpireDate(newVal) {
      this.localmenuExpireDate = newVal
    },
  },
  methods: {
    closeModal() {
      this.$emit('close-modal')
    },

    updateDocument() {
      this.$emit('update-document')
    },

    addDocument() {
      this.$emit('add-document')
    },

    createAlert() {
      this.alert = {
        description: `Identificação: ${this.newDocument.name}`,
        eventDate: this.newDocument.expireDate
          ? this.newDocument.expireDate
          : new Date(),
        alertDateTime: this.newDocument.expireDate
          ? this.newDocument.expireDate
          : new Date(),
        alertModule: 0,
        InstitutionId: JSON.parse(localStorage.getItem('institution')).id,
      }
      this.dialogKey = !this.dialogKey
      this.alertDialog = true
    },

    handleCloseDialog() {
      this.alertDialog = false
    },
  },
}
</script>
